(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('FleetDailyTripEditController', FleetDailyTripEditController);

    FleetDailyTripEditController.$inject = ['$uibModalInstance', '$filter', 'entity', 'FleetDailyTrip', 'Technicien', 'AlertService'];

    function FleetDailyTripEditController($uibModalInstance, $filter, entity, FleetDailyTrip, Technicien, AlertService) {
        var vm = this;

        vm.fleetDailyTrip = entity;
        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = { timeStart: false, timeEnd: false };
        vm.errorMessage = null;
        vm.isSaving = false;

        vm.techniciens = [];
        Technicien.technicienEnabled({}, function(list) {
            vm.techniciens = list;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function openCalendar(name) {
            vm.datePickerOpenStatus[name] = true;
        }

        function save() {
            if (!vm.fleetDailyTrip.timeStart || !vm.fleetDailyTrip.timeEnd) {
                vm.errorMessage = "Veuillez renseigner l'heure de début et l'heure de fin.";
                return;
            }
            if (vm.fleetDailyTrip.timeEnd < vm.fleetDailyTrip.timeStart) {
                vm.errorMessage = "L'heure de fin doit être postérieure à l'heure de début.";
                return;
            }
            vm.isSaving = true;
            vm.errorMessage = null;
            var payload = {
                id: vm.fleetDailyTrip.id,
                timeStart: $filter('date')(vm.fleetDailyTrip.timeStart, "yyyy-MM-dd'T'HH:mm:ss"),
                timeEnd: $filter('date')(vm.fleetDailyTrip.timeEnd, "yyyy-MM-dd'T'HH:mm:ss"),
                technicien: vm.fleetDailyTrip.technicien || null
            };
            FleetDailyTrip.update({}, payload, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError(response) {
            vm.isSaving = false;
            var msg = 'Erreur lors de la mise à jour du trajet.';
            if (response && response.data && response.data.message) {
                msg = response.data.message;
            } else if (response && response.headers) {
                var headerMsg = response.headers('X-tmgApp-error');
                if (headerMsg) {
                    msg = headerMsg;
                }
            }
            vm.errorMessage = msg;
            AlertService.error(msg);
        }
    }
})();
